/* eslint-disable max-len */

/**
 * @author: Matthew Rawson @ 27/09/2017 12:14
 * @description: Custom simple heart filled Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react"
import BaseSvgIcon from "./Base"

const SimpleHeartFilled = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path d="M14,2c2.8,0,5.1,2.3,5.1,5.1c0,1.1-0.4,2.2-1.1,3.1c0,0-1.6,1.7-3.8,4C11.4,17,11.4,17,10.5,18 c-0.1,0.1-0.3,0.2-0.4,0.2H9.9c-0.1,0-0.2-0.1-0.3-0.2l-7.1-7.1C1.5,9.7,1,8.5,1,7.1C1,4.3,3.3,2,6.1,2c1.6,0,3,0.7,4,1.9 C11,2.7,12.5,2,14,2z" />
    </BaseSvgIcon>
  )
}

export default SimpleHeartFilled
